// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"f40e0d26","729":"e78cb32b"}[chunkId] + ".css";
};